module.exports = __webpack_public_path__ + "media/passcode/loading-ab6cafe8.gif";